import { Immutable } from "immer";
import React from "react";
import { StoreSearchFilters } from "tsi-common-react/src/apps/retail/models";
import { ILocation, RetailStore } from "tsi-common-react/src/models/location";
import { jt, t } from "ttag";

import { DistanceFilter } from "../LocatorFilters_Distance";
import { LocationFilter } from "../LocatorFilters_Location";
import { RetailerFilter } from "../LocatorFilters_Retailer";
import { FilterChangeHandler } from "../models";

type IProps = Immutable<{
    filterValues: StoreSearchFilters;
    currentLocation: ILocation | null;
    allStores: ReadonlyArray<RetailStore>;
    filteredStores: ReadonlyArray<RetailStore>;
    onChange: FilterChangeHandler;
}>;

export const LocatorFilters = (props: IProps): React.ReactNode => {
    const resultsNum = (
        <span key="locator-filters-results-num" className="filters__results">
            <strong className="bh-sl-total-results">
                {props.filteredStores.length}
            </strong>{" "}
            {t`results`}
        </span>
    );
    const retailerFilter = (
        <RetailerFilter
            key="locator-filters-retailer-filter"
            filterValues={props.filterValues}
            onChange={props.onChange}
            stores={props.allStores}
        />
    );
    const distanceFilter = (
        <DistanceFilter
            key="locator-filters-distance-filter"
            filterValues={props.filterValues}
            onChange={props.onChange}
        />
    );
    const locationFilter = (
        <LocationFilter
            key="locator-filters-location-filter"
            filterValues={props.filterValues}
            currentLocation={props.currentLocation}
            onChange={props.onChange}
        />
    );
    return (
        <p className="filters__filters">
            {jt`${resultsNum} for ${retailerFilter} within ${distanceFilter} of ${locationFilter} that carry Tempur-Pedic products.`}
        </p>
    );
};
